import {
  fallbackSchema,
  recoverConfigSchema,
  scenarioSchema,
} from "@redotech/redo-model/recover-config";
import { objectId } from "@redotech/rpc/ext";
import * as z from "zod";

export const updateRecoverConfig = {
  name: "updateRecoverConfig" as const,
  input: z.object({
    id: z.string(),
    name: z.string().optional(),
    discountId: objectId().nullish(),
    agentName: z.string().optional(),
    brandName: z.string().optional(),
    supportEmail: z.string().optional(),
    scenarios: z.array(scenarioSchema).optional(),
    fallback: fallbackSchema.optional(),
  }),
  output: recoverConfigSchema,
};
